<div class="flex flex-col h-full">
  <!-- Header Section -->
  <div class="flex items-center justify-between mb-6">
    <div class="flex items-center gap-2">
      <div
        class="w-9 h-9 bg-turquoise"
        style="
          mask: url('/icons/hi-outline-cog8tooth.svg') no-repeat center / contain;
          -webkit-mask: url('/icons/hi-outline-cog8tooth.svg') no-repeat center / contain;
        "
      ></div>
      <h1 class="text-2xl font-bold text-primary">Domain Allowlist</h1>
    </div>
  </div>

  <!-- Add Domain Form -->
  <div class="mb-6 p-6 bg-base-100 border border-base-300 rounded-lg">
    <form [formGroup]="createForm" (ngSubmit)="submitCreate()" class="space-y-4">
      <h2 class="text-lg font-semibold text-primary mb-4">Add Allowed Domain</h2>

      <label class="block">
        <span class="text-base font-medium text-primary-focus mb-1 block"
          ><span class="text-error text-lg font-bold">*</span>Domain:</span
        >
        <input
          class="input input-bordered w-full h-10 min-h-10 px-3 text-sm rounded mt-1 border-base-300 text-primary placeholder:text-icon-inactive focus:outline-none focus:border-base-300"
          formControlName="domain"
          placeholder="e.g. example.edu"
        />
        <div
          class="text-xs text-error mt-1"
          *ngIf="createForm.get('domain')?.invalid && (createForm.get('domain')?.touched || createForm.get('domain')?.dirty)"
        >
          Please enter a valid domain.
        </div>
      </label>

      <label class="block">
        <span class="text-base font-medium text-primary-focus mb-1 block">Description (optional):</span>
        <input
          class="input input-bordered w-full h-10 min-h-10 px-3 text-sm rounded mt-1 border-base-300 text-primary placeholder:text-icon-inactive focus:outline-none focus:border-base-300"
          formControlName="description"
          placeholder="Label for this domain"
        />
      </label>

      <div class="flex justify-end pt-2">
        <button
          type="submit"
          class="h-8 px-6 min-w-[160px] border border-base-300 rounded text-sm text-dark font-medium hover:bg-info hover:text-white transition-colors"
          [disabled]="createForm.invalid || isSubmitting"
        >
          Add Domain
        </button>
      </div>
    </form>
  </div>

  <!-- Allowed Domains Table -->
  <div class="flex-1 overflow-hidden" [formGroup]="editForm">
    <h3 class="text-lg font-semibold text-primary mb-4">Allowed Domains</h3>
    <div class="overflow-x-auto bg-base-100">
      <table class="table w-full text-sm">
        <thead class="bg-base-200">
          <tr class="h-[55px]">
            <th class="py-3 px-4 text-left font-bold text-base text-primary">Domain</th>
            <th class="py-3 px-4 text-left font-bold text-base text-primary">Description</th>
            <th class="py-3 px-4 font-bold text-base text-primary">Actions</th>
          </tr>
        </thead>
        <tbody *ngIf="items().length > 0; else emptyState">
          <tr *ngFor="let item of items(); trackBy: trackById" class="h-[55px] even:bg-base-200">
            <td class="py-3 px-4 text-sm text-primary font-medium" *ngIf="editingId !== item.id; else editDomain">
              {{ item.domain }}
            </td>
            <td class="py-3 px-4 text-sm text-primary font-medium" *ngIf="editingId !== item.id; else editDesc">
              {{ item.description || '—' }}
            </td>
            <td class="py-3 px-4" *ngIf="editingId !== item.id; else editActions">
              <div class="flex items-center gap-2">
                <button
                  class="cursor-pointer text-primary-focus hover:text-primary transition-colors"
                  (click)="beginEdit(item)"
                  aria-label="Edit"
                >
                  <fa-icon [icon]="'edit'" class="h-4 w-4"></fa-icon>
                </button>
                <button
                  class="cursor-pointer text-primary-focus hover:text-error transition-colors"
                  (click)="delete(item.id)"
                  aria-label="Delete"
                >
                  <fa-icon [icon]="'trash'" class="h-4 w-4"></fa-icon>
                </button>
              </div>
            </td>

            <ng-template #editDomain>
              <td class="py-3 px-4">
                <input
                  class="input input-bordered w-full h-10 min-h-10 px-3 text-sm rounded border-base-300 text-primary focus:outline-none focus:border-base-300"
                  formControlName="domain"
                />
              </td>
            </ng-template>
            <ng-template #editDesc>
              <td class="py-3 px-4">
                <input
                  class="input input-bordered w-full h-10 min-h-10 px-3 text-sm rounded border-base-300 text-primary focus:outline-none focus:border-base-300"
                  formControlName="description"
                />
              </td>
            </ng-template>
            <ng-template #editActions>
              <td class="py-3 px-4">
                <div class="flex items-center gap-2">
                  <button
                    class="cursor-pointer text-primary-focus hover:text-info transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    (click)="saveEdit()"
                    [disabled]="editForm.invalid"
                    aria-label="Save"
                  >
                    <fa-icon [icon]="'check'" class="h-4 w-4"></fa-icon>
                  </button>
                  <button
                    class="cursor-pointer text-primary-focus hover:text-base-content/70 transition-colors"
                    (click)="cancelEdit()"
                    aria-label="Cancel"
                  >
                    <fa-icon [icon]="'times'" class="h-4 w-4"></fa-icon>
                  </button>
                </div>
              </td>
            </ng-template>
          </tr>
        </tbody>
        <ng-template #emptyState>
          <tr>
            <td colspan="3" class="py-8 text-center text-sm text-base-content/70">No allowed domains</td>
          </tr>
        </ng-template>
      </table>
    </div>
  </div>
</div>
